import React, { Component } from 'react';

import moment from 'moment';
import { pick } from 'ramda';
import { toast } from 'react-toastify';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner
} from 'reactstrap';

import { activateCovenant } from '../services';

const formattedDateTime = moment().format('YYYY-MM-DD HH:mm:ss');

class Covenant extends Component {
  state = {
    establishmentId: sessionStorage.getItem('establishmentId'),
    typePrice: sessionStorage.getItem('typePrice'),
    dateTime: formattedDateTime,
    code: '',
    loading: false
  }

  componentDidMount() {
    const { establishmentId } = this.state;
    const { history } = this.props;

    if(!establishmentId) {
      history.push('/');
    }
  }

  handleActivation = () => {
    const params = pick(['code', 'establishmentId', 'typePrice'], this.state);

    this.setState({ loading: true });

    return activateCovenant(params)
      .then(({ data }) => {
        toast.success(data.msg);
        return this.setState({ code: '', loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  handleToLogout = () => {
    const { history } = this.props;

    sessionStorage.clear();
    history.push('/');
  }

  render() {
    const { code, loading } = this.state;

    return(
      <div
        className="h-100 w-100 d-flex align-items-center"
        style={{ backgroundColor: '#022A5C' }}
      >
        <Container>
          <Row>
            <Col md={6} className="mx-auto">
              <Card>
                <CardHeader>Ativação do convênio</CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label>Número do cartão / Placa do veículo</Label>
                    <Input
                      placeholder="Digite o n˚ do cartão ou a placa do veículo"
                      onKeyPress={event => event.key === 'Enter' ? this.handleActivation : null}
                      onChange={event => this.setState({ code: event.target.value })}
                      disabled={loading}
                      value={code}
                    />
                  </FormGroup>
                  <Button
                    block
                    style={{ backgroundColor: '#13BC4B', borderColor: '#13BC4B' }}
                    disabled={loading || !code}
                    onClick={this.handleActivation}
                  >
                    {
                      loading
                        ? <Spinner size="sm" color="white" />
                        : 'Ativar convênio'
                    }
                  </Button>
                </CardBody>
                <CardFooter className='text-center'>
                  <Button
                    color='link'
                    className='text-danger'
                    disabled={loading}
                    onClick={this.handleToLogout}
                  >
                    Sair
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Covenant;


// WEBPACK FOOTER //
// ./src/pages/Covenant/components/Covenant.js